<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary ">
          <b-row align-v="center">
            <b-col>
              <h1>
                <feather-icon icon="ListIcon" size="30" class="mr-50" /> Todos os Desafios
              </h1>
              <h4 class="mt-1">Selecione um desafio:</h4>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-input-group class="input-group-merge mb-2">
      <b-input-group-prepend is-text>
        <feather-icon icon="SearchIcon" />
      </b-input-group-prepend>
      <b-form-input placeholder="Pesquisar Instituição" />
    </b-input-group>
    
    <b-card no-body class="mb-0">
      <b-table
        ref="refUserListTable"
        style="min-height: 50vw"
        class="position-relative"
        :items="tableItems"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- <template #cell(nome)>
          <h5>Centro Pernambucano de Psicologia Aplicada</h5>
        </template> -->

        <template #cell(cadastro)="data">
          {{ data.item.createdAt }}
        </template>

        <template #cell(localizacao)="data">
          {{ data.item.physicalPerson.person.city }} -
          {{ data.item.physicalPerson.person.state }}
        </template>

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.role)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.role)}`"
            />
            <span class="align-text-top text-capitalize">{{
              data.item.role
            }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(
              data.item.physicalPerson.person.status
            )}`"
            class="text-capitalize"
          >
            {{ resolveUserStatusText(data.item.physicalPerson.person.status) }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <!-- <b-dropdown-item
              :to="{ name: 'pacienteEdit', params: { id: data.item.id } }"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item> -->
            <!--Mostrar apenas se tiver alguma consulta marcada -->
            
            <b-dropdown-item
              :to="{ name: 'editarDesafio', params: { id: data.item.id} }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar Quiz</span>
            </b-dropdown-item>

            
          </b-dropdown>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BDropdown,
  BDropdownItem,
  BBadge,
  BLink,
  BMedia,
  BAvatar,
  BButton,
  BCol,
  BRow,
  BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BFormGroup, BFormTextarea
} from 'bootstrap-vue'
import { title } from '@/@core/utils/filter'
import challengeService from '@/services/challengeService'
import {hideSpinner, showSpinner } from '@/services/spinService'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BTable,
    BDropdown,
    BDropdownItem,
    BBadge,
    BLink,
    BMedia,
    BAvatar,
    BCol,
    BRow,
    BButton,
    BFormTextarea,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
  },
   directives: {
    Ripple,
  },
  methods: {
    // resolveUserRoleVariant: role => {
    //   if (role === 'paciente') return 'primary'
    //   if (role === 'author') return 'warning'
    //   if (role === 'maintainer') return 'success'
    //   if (role === 'editor') return 'info'
    //   if (role === 'admin') return 'danger'
    //   return 'primary'
    // },
    // resolveUserRoleIcon: role => {
    //   if (role === 'paciente') return 'UserIcon'
    //   if (role === 'author') return 'SettingsIcon'
    //   if (role === 'maintainer') return 'DatabaseIcon'
    //   if (role === 'editor') return 'Edit2Icon'
    //   if (role === 'admin') return 'ServerIcon'
    //   return 'UserIcon'
    // },
    resolveUserStatusText: status => {
      if (status === 'abandono') return 'warning'
      if (status === 'ACTIVE') return 'ativo'
      if (status === 'alta') return 'primary'
      if (status === 'óbito') return 'danger'
      return ''
    },

    resolveUserStatusVariant: status => {
      if (status === 'abandono') return 'warning'
      if (status === 'ACTIVE') return 'success'
      if (status === 'alta') return 'primary'
      if (status === 'óbito') return 'danger'
      return 'primary'
    },
      prepareRequest(obj) {
      return {
        ...obj,
        page: 1,
        itemsPerPage: 100,
      }
    },
    async fetchChallenges() {
      showSpinner()
      const response = await challengeService.getAll(this.prepareRequest({ name: this.searchQuery }))
      this.tableItems = response.content
      hideSpinner()
    },
  },
  data: () => ({
    tableItems: [],
    perPage: 10,
    totalItems: 0,
    currentPage: 1,
    perPageOptions: [10, 25, 50, 100],
    searchQuery: '',
    sortBy: 'id',
    isSortDirDesc: true,
    roleFilter: null,
    planFilter: null,
    statusFilter: null,
    tableColumns: [
      { key: 'name', label: 'Nome', sortable: true },
      { key: 'description', label: 'Descrição', sortable: true },
      { key: 'model', label: 'Modelo', sortable: true },
      // { key: 'Tipo', label: 'Tipo', sortable: true },
      // { key: 'Duracao', label: 'Duração', sortable: true },
      // { key: 'Instituição', label: 'Instituição', sortable: true },
      // { key: 'Autor', label: 'Autor', sortable: true },
      // { key: 'status', sortable: true },
      { key: 'actions', label: 'Acesso', sortable: false },
    ],
  }),
  mounted() {
    this.fetchChallenges()
  },
}
</script>
